import { formatNumber } from "@angular/common";

export function formatNumberWithPrefix(value: number, locale: string = "de", digitsInfo?: string): string {
  const _prefix = value > 0 ? "+" : "";
  return `${_prefix}${formatNumber(value, locale, digitsInfo)}`;
}
